import httpClient from './httpClient'

export async function runRegression({ file, stateCode }) {
  const formData = new FormData()

  formData.append('file', file)
  formData.append('stateCode', stateCode)

  const { data } = await httpClient.post(
    '/api/regression/run',
    formData,
    
  )

  return data
}